import React from 'react'

const CircularProgress = (props: {
  progress: number
  fillColor?: string
  bgColor?: string
  inactiveColor?: string
  className?: string
  radiusWidth?: number
}) => {
  const {
    progress,
    className = 'h-6 w-6',
    fillColor = 'text-white',
    bgColor = 'text-zinc-800',
    inactiveColor = 'text-black',
    radiusWidth
  } = props

  return (
    <svg className={className} fill="currentColor" viewBox="0 0 200 200">
      <circle
        r="70"
        cx="100"
        cy="100"
        className={`stroke-current ${inactiveColor}`}
        strokeDasharray="565.48"
        strokeDashoffset="0"
        strokeWidth="60"
      />
      <circle
        r="70"
        cx="100"
        cy="100"
        className={`stroke-current ${fillColor}`}
        strokeDasharray="565.48"
        strokeDashoffset="0"
        strokeWidth="60"
        style={{
          strokeDashoffset: `-${436 * (1 - progress)}px`
        }}
      />
      <circle
        r={radiusWidth || 75}
        cx="100"
        cy="100"
        className={`fill-current ${bgColor}`}
      />
    </svg>
  )
}

export default CircularProgress
